webpackJsonp([7],{

/***/ "Rvxz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./app/elements/Lightbox.ts
var Lightbox = __webpack_require__("FK8Y");

// EXTERNAL MODULE: ./app/utils/getDetailsContent.ts
var getDetailsContent = __webpack_require__("kLL2");

// EXTERNAL MODULE: ./utils/nodes/getClosestByTagName.ts
var getClosestByTagName = __webpack_require__("kz2+");

// CONCATENATED MODULE: ./app/Routes/Decoration/Sections/index.ts




var detailsWithLoadedImages = new WeakSet();
/**
 * Карточки интерьеров квартир.
 */
function main() {
    var sectionsContainer = document.querySelector('main>div.sections');
    if (!sectionsContainer) {
        return;
    }
    sectionsContainer.addEventListener('click', onSectionClick);
}
function onSectionClick(event) {
    var article = Object(getClosestByTagName["a" /* default */])(event.target, 'SECTION');
    if (!article) {
        return;
    }
    var details = article.querySelector('section>details');
    if (!details) {
        return;
    }
    if (!detailsWithLoadedImages.has(details)) {
        detailsWithLoadedImages.add(details);
        loadImages(details);
    }
    var lightbox = Lightbox["a" /* default */].instance;
    event.preventDefault();
    lightbox.open(Object(getDetailsContent["a" /* default */])(details));
}
function loadImages(container) {
    var links = container.querySelectorAll('ul.images>li>a');
    for (var i = 0, n = links.length; i < n; i++) {
        replaceLinkToImage(links[i]);
    }
}
function replaceLinkToImage(link) {
    var parent = link.parentNode;
    var href = link.getAttribute('href');
    if (!parent || !href) {
        return;
    }
    var image = new Image();
    image.alt = link.textContent || '';
    image.src = href;
    parent.replaceChild(image, link);
}
/**
 * Module.
 */


// CONCATENATED MODULE: ./app/Routes/Decoration/index.ts
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Decoration_main; });


/**
 * Страница «Отделка квартир».
 */
function Decoration_main() {
    main();
}
/**
 * Module.
 */



/***/ }),

/***/ "kLL2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getDetailsContent; });

/**
 * Get content of `<details>` tag
 *
 * @param details Details tag element.
 * @returns Content of tag except `<summary>`.
 */
function getDetailsContent(details) {
    var nodes = [];
    for (var i = 0, n = details.childNodes.length; i < n; i++) {
        var node = details.childNodes[i];
        if (node.nodeName !== 'SUMMARY') {
            nodes.push(node);
        }
    }
    return nodes;
}
/**
 * Module
 */



/***/ }),

/***/ "kz2+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getClosestByTagName; });

/**
 * Взять ближайший родительский элемент с указанным именем тэга.
 *
 * @param element Исходный элемент.
 * @param tagName Имя тэга.
 */
function getClosestByTagName(element, tagName) {
    var currentElement = element;
    while ((currentElement !== null)
        && (currentElement.tagName !== tagName)) {
        currentElement = currentElement.parentElement;
    }
    return currentElement;
}
/**
 * Module.
 */



/***/ })

});


// WEBPACK FOOTER //
// chunk-decoration.87daf52e9ac4608f9441.js